import { render, staticRenderFns } from "@/clickbuy/convocation/views/participant-list/participant-list.pug?vue&type=template&id=277023ae&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/clickbuy/convocation/views/participant-list/participant-list.scss?vue&type=style&index=0&id=277023ae&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277023ae",
  null
  
)

export default component.exports